const production = {
  url: "https://protokol.kociuk.pl:3000",
}
const development = {
  url: "https://protokol.kociuk.pl:3000",
}
export const config =
  process.env.NODE_ENV === "development" ? development : production
